export const isCancelAndHoldAutomationEvent = (automationEvent) => {
    return automationEvent.type === 'cancelAndHold';
};
//# sourceMappingURL=cancel-and-hold-automation-event.js.map